import { Point, Sprite, Text, TextStyle } from "pixi.js";
import { VBox } from "../../../common/components/ui/VBox";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { CheckoutPiggyDescriptionComponent } from "./CheckoutPiggyDescriptionComponent";
import { GameFont } from "../../../common/GameFont";
import { DropShadowFilter } from "pixi-filters";
import { CheckoutPiggyResourcePackage } from "../resources/CheckoutPiggyResourcePackage";

export class CheckoutPiggyClaimDescriptionComponent extends CheckoutPiggyDescriptionComponent {
    private static readonly CLAIM_TEXT = 'CLAIM LATER';
    private static readonly ALONG_TEXT = 'ALONG WITH OTHER';
    private static readonly FANTASTIC_TEXT = 'FANTASTIC BENEFITS AND REWARDS';

    private readonly claimText: Text;
    private readonly alongText: Text;
    private readonly fantasticText: Text;
    private readonly token: Sprite;

    public constructor(commonResources: CommonResourcesPackage, introResources: CheckoutPiggyResourcePackage) {
        super(commonResources);
        const vBox = new VBox(16);
        this.descriptionContent.addChild(vBox);
        this.claimText = new Text(CheckoutPiggyClaimDescriptionComponent.CLAIM_TEXT, new ClaimTextStyle());
        this.alongText = new Text(CheckoutPiggyClaimDescriptionComponent.ALONG_TEXT, new AlongTextStyle());
        this.fantasticText = new Text(CheckoutPiggyClaimDescriptionComponent.FANTASTIC_TEXT, new FantasticTextStyle());
        this.fantasticText.filters = [new DropShadowFilter({
            offset: new Point(0, 0),
            blur: 15,
            color: 0x5DA7FF,
            quality: 4.5,
            alpha: 1,
            pixelSize: 0.7
        })];
        vBox.addChild(this.claimText, this.alongText, this.fantasticText);
        this.token = new Sprite(introResources.assets_views_piggy_intro_token_png);
        this.token.width = this.token.height = 215;
        this.token.angle = 33.24;
        this.token.position.set(-144, -124);
        this.addChild(this.token);
    }
}

class ClaimTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 96,
            fill: [
                'AAFD09',
                '16CF15'
            ],
            trim: true
        });
    }
}

class AlongTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 46,
            fill: 'FFFFFF',
            trim: true
        });
    }
}

class FantasticTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 46,
            fill: [
                'AAFD09',
                '16CF15'
            ],
            trim: true
        });
    }
}